import { render } from "./PlayersView.vue?vue&type=template&id=899f031a&scoped=true"
import script from "./PlayersView.vue?vue&type=script&lang=js"
export * from "./PlayersView.vue?vue&type=script&lang=js"

import "./PlayersView.vue?vue&type=style&index=0&id=899f031a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-899f031a"]])

export default __exports__